module.exports = __webpack_public_path__ + "img/error.4dc08019.svg";